import * as React from 'react'
import tw from 'tailwind-styled-components'
import {noPropagate} from '@containers/hooks'
import {cn} from '@containers/html-utils'

export interface Props {
  header?: React.ReactNode
  footer?: React.ReactNode
  children: React.ReactNode
  className?: string
  disableHeaderMargin?: boolean
  bodyScroll?: boolean
  footerClassName?: string
  headerClassName?: string
  style?: React.CSSProperties
}

const TwHeader = tw.div`
  shrink-0
  bg-header-old
  font-semibold
  text-14
  leading-none
  border-main-old
  border-0
  border-b
  border-solid
  px-8
  flex
  items-center
  justify-between
  h-32
`

const TwFooter = tw.div`
  shrink-0
  border-main-old
  border-0
  border-t
  border-solid
  px-4
  flex
  items-center
  h-32
`

const TwDropdownContent = tw.div`
  flex
  rounded-4
  bg-main-old
  flex-col
  text-main-old
  select-none
  cursor-default
`

/**
 * @notice This component is shared to the platform APi, so you can't change its API
 * @param props
 * @constructor
 */
export const DropdownContent = (props: Props) => {
  return (
    <TwDropdownContent
      onClick={noPropagate}
      onMouseDown={noPropagate}
      className={props.className}
      style={props.style}
    >
      {props.header && (
        <TwHeader
          className={cn(
            !props.disableHeaderMargin && 'mb-4',
            props.headerClassName
          )}
        >
          {props.header}
        </TwHeader>
      )}
      <div
        className={cn(
          'flex-1',
          props.bodyScroll ? 'overflow-y-auto' : 'overflow-hidden '
        )}
      >
        {props.children}
      </div>
      {props.footer && (
        <TwFooter className={props.footerClassName}>{props.footer}</TwFooter>
      )}
    </TwDropdownContent>
  )
}
